module.exports = __webpack_public_path__ + "static/img/banner_joinus.1534f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/banner_joinus.png
// module id = gAxy
// module chunks = 15